import { render, staticRenderFns } from "./homeLiveTopics.vue?vue&type=template&id=24843618&scoped=true&"
import script from "./homeLiveTopics.vue?vue&type=script&lang=js&"
export * from "./homeLiveTopics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24843618",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24843618')) {
      api.createRecord('24843618', component.options)
    } else {
      api.reload('24843618', component.options)
    }
    module.hot.accept("./homeLiveTopics.vue?vue&type=template&id=24843618&scoped=true&", function () {
      api.rerender('24843618', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Homelive/components/homeLiveTopics.vue"
export default component.exports